export default __webpack_public_path__ + "static/media/machine-to-machine-chatbot.95fd11c0.png";